const MEDIA_URL = 'https://dzniw0su9j7m4.cloudfront.net/asset';

export const logoImageLight = `${MEDIA_URL}/logo.png`;
export const logoImageDark = `${MEDIA_URL}/logo-dark.png`;
export const logoEvent = `${MEDIA_URL}/event`;
export const signinImage = `${MEDIA_URL}/signin.jpg`;

export const sectorBanner = `${MEDIA_URL}/sectorbanner.jpg`;
